// extracted by mini-css-extract-plugin
module.exports = {"WhiteBtn":"WhiteBtn_WhiteBtn__3kosh","WhiteBtnTxt":"WhiteBtn_WhiteBtnTxt__1T3jn"};